import React from 'react';
import {view} from '@sail/ui';

import {MEDIA_QUERIES} from 'src/v2/util/mediaQueries';

export const ScreenContentLayout = ({
  children,
  bottom,
}: {
  children: React.ReactNode;
  bottom?: React.ReactNode;
}): React.ReactElement => {
  return (
    <view.div
      css={{
        stack: 'y',
        width: '388px',
        minWidth: '388px',
        gapY: 'large',
        boxShadow:
          '0px -4px 32px 0px rgba(0, 0, 0, 0.04), 0px 12px 32px 0px rgba(0, 0, 0, 0.04)',
        borderRadius: '20px',
        borderWidth: 'small',
        borderStyle: 'solid',
        borderColor: 'form',
        paddingX: 'large',
        paddingY: 'xlarge',
        height: 'fit',
        [MEDIA_QUERIES.smallWidth]: {
          width: 'fill',
        },
        [MEDIA_QUERIES.mediumWidth]: {
          boxShadow: 'none',
          borderStyle: 'none',
          paddingX: '16px',
          paddingY: '16px',
        },
        [MEDIA_QUERIES.mediumWidthHeight]: {
          distribute: 'space-between',
          height: '100%',
        },
      }}
    >
      <view.div css={{stack: 'y', gapY: 'large', height: 'fit'}}>
        {children}
      </view.div>
      {bottom}
    </view.div>
  );
};
